import React from 'react';
import Slider from '@material-ui/core/Slider';

export default function CameraSlider({cb, value}) {
  const updatePreset = (e, v) => {
    if (v !== value) {
      cb(v)
    }
    return
  }

  return (
    <div className={"max-width"}>
      <Slider
        defaultValue={.5}
        value={value}
        onChange={updatePreset}
        step={.1}
        min={.1}
        max={1}
        valueLabelDisplay={"off"}
      />
    </div>
  );
}